{
  "v4Locale": "es-ES",
  "currency": "EUR",
  "territories": [
    "ES"
  ],
  "currentLang": "ES"
}